import { Injectable } from '@angular/core';

import { CustomerCorrespondence } from 'src/app/models/customer/CustomerCorrespondence';

import { GenericService } from 'src/app/services/api/generic.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerCorrespondenceService extends GenericService<CustomerCorrespondence> {
  constructor() {
    super();
    this.setContext('customer-correspondences');
  }

  override lazyLoad(): never {
    throw new Error('Method not implemented.');
  }
}
